import lessRequire from '../../../config/less-require-resolver';
import { actions, selectors } from './';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import cn from 'classname';
import renderViewsState from '../../shared/render-views-state';

import OffersTable from '../components/table/main';
import Rules from '../components/popups/rules';

import Filters from '../components/filters/main';

lessRequire('modules/offers/list/main.less');

class FilterContainer extends React.Component {
	render() {
		return (
			<div className="container__content">
				<div className="filters-positioning scrolled-to-bottom">
					<div id="offers__filter">
						<Filters {...this.props} initialValues={this.props.formData.initialValue} enableReinitialize={true} />
					</div>
				</div>
				{(!this.props.userIsMaster && this.props.shouldShowBoostBanner)
					&& <BoostBanner intl={this.props.intl} />}
			</div>
		);
	}
}

FilterContainer.propTypes = {
	formData: PropTypes.object,
	shouldShowBoostBanner: PropTypes.bool,
	intl: PropTypes.func,
	userIsMaster: PropTypes.bool
};

const Main = renderViewsState(props => (
	<div className={cn({
		'offers container': true,
		'with-booster-banner': !props.userIsMaster && props.shouldShowBoostBanner
	})}>
		<div className='offers__list'>
			<FilterContainer {...props}/>
			<div className="offers-half__list">
				<OffersTable
					tableRows={props.dataTable.data}
					showMore={props.pagination().showMore}
					isCanNotMoveToNext={props.dataTable.isCanNotMoveToNext}
					{...props}
				/>
				<Rules {...props} />
			</div>
		</div>
	</div>
));

const BoostBanner = ({ intl }) => (
	<div className="boost-banner">
		<span className="leading-text font-proxima-nova-semibold">
			{intl('Активируй опцию ')}
			<span className="boost-text">
				Boost
				<span className="dialog-box font-proxima-nova-regular">
					{intl(
						'Опция Boost может быть активирована только при условии базовой выплаты на оффере/гео.' +
							' Если с менеджером согласован индивидуальный размер выплаты, то опция недоступна.'
					)}
					<svg className="tick" xmlns="http://www.w3.org/2000/svg" width="13" height="15" fill="#fffaf4">
						<polygon points="-1 -1, 12 -1, 12 15" stroke="#ffd59f" />
					</svg>
					<span className="icon-boost-round" />
				</span>
			</span>
			{intl(' на 7 дней и выжми максимум профита!')}
		</span>
		<span className="percent-text font-proxima-nova-semibold"></span>
		<span className="ending-text font-proxima-nova-regular"></span>
	</div>
);

BoostBanner.propTypes = {
	intl: PropTypes.func
};

export default connect(
	state => ({
		data: selectors.getData(state),
		activeOfferData: selectors.getActiveOfferData(state),
		dataTable: selectors.getTableData(state),
		managerData: selectors.getManagerData(state),
		tableHeaders: selectors.getTableHeaders(state),
		rowsCount: selectors.getRowsCount(state),
		columnSorting: selectors.getColumnSorting(state),
		switchControlConfig: selectors.getSwitchControlsConfig(state),
		tableId: selectors.getTableId(state),
		formData: selectors.getFormData(state),
		intl: selectors.getIntl(state),
		lists: selectors.getLists(state),
		error: selectors.getError(state),
		affiliateLevels: selectors.getAffiliateLevels(),
		user: selectors.getUser(state),
		userIsMaster: selectors.getIsUserMaster(state),
		offerInfo: selectors.getOfferInfo(state),
		shouldShowBoostBanner: selectors.getShouldShowBoostBanner(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/offers/list/main.js